import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { RootErrorBoundary } from "./components/errors/RootErrorBoundary";
import "./index.css";

// Defense-in-depth: force HTTPS upgrade on the client.
// Real protection still requires HSTS as an HTTP header on the host.
if (
  typeof window !== "undefined" &&
  window.location.protocol === "http:" &&
  !["localhost", "127.0.0.1"].includes(window.location.hostname)
) {
  window.location.replace(
    "https://" +
      window.location.host +
      window.location.pathname +
      window.location.search +
      window.location.hash,
  );
}

// Guard: unregister service workers in iframe/preview contexts
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  navigator.serviceWorker
    ?.getRegistrations()
    .then((regs) => {
      regs.forEach((r) => r.unregister());
    })
    .catch(() => {
      /* SW unregister best-effort; ignore failures */
    });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </HelmetProvider>
);
